/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2636__part-1
 */

"use strict"

import /* 0 */"react"
import * as /* [auto-meaningful-name] */React from "react"
import /* [auto-meaningful-name] */React1 from /* 0 */"react"
import * as /* [auto-meaningful-name] */ReactDom from /* 80 */"react-dom"
import /* [auto-meaningful-name] */ReactDom1 from /* 80 */"react-dom"
import /* 16 */"react-redux"
import /* 481 */"./481/index";
(function () {
  function e() {
    var t = Error.call(this, "ServiceWorker is not supported.")
    Object.setPrototypeOf(t, e.prototype)
    return t
  }
  e.prototype = Object.create(Error.prototype)
})()
var v = "https://creation.codemao.cn/coconut/web/1.22.0-0/" + "main.sw.js"
export { v }
